import { useCallback, useState } from "react";
import { applyManufacturingNamedVariantToRecipes } from "@/lib/manufacturing/namedVariantsClient";

/** Apply-to-many state + long-running busy flag for the wait banner. */
export function useNamedVariantApplyToRecipes(
  selectedId: string | null,
  reloadDetail: (id: string) => Promise<void>,
  reloadList: () => Promise<void>,
  setSaveBusy: (busy: boolean) => void,
  setLocalError: (error: string | null) => void,
) {
  const [applyDescription, setApplyDescription] = useState("");
  const [applyParentIds, setApplyParentIds] = useState<string[]>([]);
  const [applyBusy, setApplyBusy] = useState(false);
  const [applyRecipeCount, setApplyRecipeCount] = useState(0);

  const onApplyToRecipes = useCallback(async () => {
    if (!selectedId || applyParentIds.length === 0) return;
    const count = applyParentIds.length;
    setSaveBusy(true);
    setApplyBusy(true);
    setApplyRecipeCount(count);
    setLocalError(null);
    const r = await applyManufacturingNamedVariantToRecipes({
      named_variant_id: selectedId,
      parent_recipe_ids: applyParentIds,
      description: applyDescription,
    });
    setSaveBusy(false);
    setApplyBusy(false);
    setApplyRecipeCount(0);
    if (!r.ok) {
      setLocalError(r.error);
      return;
    }
    setApplyParentIds([]);
    await reloadDetail(selectedId);
    await reloadList();
  }, [
    selectedId,
    applyParentIds,
    applyDescription,
    reloadDetail,
    reloadList,
    setSaveBusy,
    setLocalError,
  ]);

  return {
    applyDescription,
    setApplyDescription,
    applyParentIds,
    setApplyParentIds,
    applyBusy,
    applyRecipeCount,
    onApplyToRecipes,
  };
}
